import React, {Suspense} from 'react'
import {BrowserRouter} from 'react-router-dom'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import AuthInit from './modules/auth/redux/AuthInit'
import {Routes} from './routing/Routes'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'leaflet/dist/leaflet.css'
import {SubmenuProvider} from '../_metronic/layout/components/header/SubmenuContext'

type Props = {
    basename: string
}

const App: React.FC<Props> = ({basename}) => {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <BrowserRouter basename={basename}>
                <LayoutProvider>
                    <AuthInit>
                        <SubmenuProvider>
                            <Routes />
                            <ToastContainer autoClose={5000} />
                        </SubmenuProvider>
                    </AuthInit>
                </LayoutProvider>
            </BrowserRouter>
        </Suspense>
    )
}

export {App}
